import { types } from 'mobx-state-tree';

export const AvailableGame = types.model({
    Id: types.string,
    Visible: types.boolean,
    Name: types.string
});
